{
  "name": "ir-ng-fe",
  "version": "0.0.3",
  "scripts": {
    "watch": "ng test",
    "build": "./scripts/version.sh && ng build --output-hashing all",
    "install": "cp ./package.json ./src/assets",
    "lint": "ng lint",
    "ng": "ng",
    "start": "cp ./package.json ./src/assets && ng serve --ssl --host localhost.sparbanken.me",
    "style-lint": "stylelint  src/**/*.scss --fix",
    "test": "ng test --watch=false --code-coverage"
  },
  "private": true,
  "dependencies": {
    "@angular/animations": "^20.3.6",
    "@angular/cdk": "^20.2.9",
    "@angular/common": "^20.3.6",
    "@angular/compiler": "^20.3.6",
    "@angular/core": "^20.3.6",
    "@angular/forms": "^20.3.6",
    "@angular/material": "20.2.10",
    "@angular/platform-browser": "^20.3.6",
    "@angular/platform-browser-dynamic": "^20.3.6",
    "@angular/router": "^20.3.6",
    "rxjs": "~7.8.0",
    "tslib": "^2.3.0",
    "zone.js": "~0.15.0"
  },
  "devDependencies": {
    "@angular/build": "^20.3.6",
    "@angular/cli": "^20.3.6",
    "@angular/compiler-cli": "^20.3.6",
    "@eslint/js": "^9.23.0",
    "@sparbanken-syd/auth-backend": "^2.3.6",
    "@sparbanken-syd/personnummer": "^3.0.1",
    "@sparbanken-syd/sparbanken-syd-bankid": "20.2.2 ",
    "@sparbanken-syd/sparbanken-syd-qr": "^20.0.0",
    "@sparbanken-syd/sparbanken-syd-theme": "20.3.0",
    "@sparbanken-syd/sparbanken-syd-theme-m3": "^20.0.1",
    "@types/jasmine": "~5.1.0",
    "angular-eslint": "20.5.0",
    "echarts": "^5.6.0",
    "eslint": "^9.28.0",
    "jasmine-core": "~5.8.0",
    "karma": "~6.4.4",
    "karma-chrome-launcher": "~3.2.0",
    "karma-coverage": "~2.2.1",
    "karma-jasmine": "~5.1.0",
    "karma-jasmine-html-reporter": "~2.1.0",
    "ngx-echarts": "^20.0.0",
    "postcss": "^8.5.6",
    "stylelint": "^16.17.0",
    "stylelint-config-sass-guidelines": "^12.1.0",
    "stylelint-config-standard-scss": "^14.0.0",
    "typescript": "~5.8.3",
    "typescript-eslint": "^8.33.1"
  }
}
